var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/error-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z M12,5.45454545 C8.38504527,5.45454545 5.45454545,8.38504527 5.45454545,12 C5.45454545,15.6149547 8.38504527,18.5454545 12,18.5454545 C15.6149547,18.5454545 18.5454545,15.6149547 18.5454545,12 C18.5454545,8.38504527 15.6149547,5.45454545 12,5.45454545 Z M12.0072727,14.9090909 C12.4089344,14.9090909 12.7345455,15.234702 12.7345455,15.6363636 C12.7345455,16.0380253 12.4089344,16.3636364 12.0072727,16.3636364 C11.5983384,16.3636364 11.2727273,16.0380253 11.2727273,15.6363636 C11.2727273,15.234702 11.5983384,14.9090909 12,14.9090909 Z M12,7.27667293 C12.4102687,7.27667293 12.7428571,7.60926141 12.7428571,8.01953008 L12.7428571,13.0466997 C12.7428571,13.4569684 12.4102687,13.7895569 12,13.7895569 C11.5897313,13.7895569 11.2571429,13.4569684 11.2571429,13.0466997 L11.2571429,8.01953008 C11.2571429,7.60926141 11.5897313,7.27667293 12,7.27667293 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/error-white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/error",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWhite);
export default __webpack_public_path__ + "static/media/error-white.178658c65299cd3161c9273cff514f9f.svg";
export { ForwardRef as ReactComponent };